import React from 'react';
import { motion } from 'framer-motion';
import { Star } from 'lucide-react';
import { useLanguage } from '../context/LanguageContext';
export function TestimonialsSection() {
  const {
    t
  } = useLanguage();
  const testimonials = [{
    quote: t('testimonials.quote1'),
    author: 'Carlos M.',
    role: t('testimonials.role1'),
    location: 'Newark, NJ'
  }, {
    quote: t('testimonials.quote2'),
    author: 'Dr. Rafael S.',
    role: t('testimonials.role2'),
    location: 'Jersey City, NJ'
  }, {
    quote: t('testimonials.quote3'),
    author: 'Miguel A.',
    role: t('testimonials.role3'),
    location: 'Elizabeth, NJ'
  }];
  return <section className="bg-brand-alt py-16 md:py-24" data-id="element-175">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-176">
        <motion.div className="text-center mb-16" initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.5
      }} data-id="element-177">
          <h2 className="text-3xl md:text-4xl font-bold text-brand-navy" data-id="element-178">
            {t('testimonials.title')}
          </h2>
        </motion.div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-8" data-id="element-179">
          {testimonials.map((testimonial, index) => <motion.div key={index} className="bg-white rounded-2xl p-8 shadow-md border border-brand-primary/20 flex flex-col h-full" initial={{
          opacity: 0,
          y: 30
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.5,
          delay: index * 0.15
        }} data-id="element-180">
              <div className="flex space-x-1 mb-6" data-id="element-181">
                {[...Array(5)].map((_, i) => <Star key={i} className="w-5 h-5 fill-brand-accent text-brand-accent" data-id="element-182" />)}
              </div>
              <p className="text-brand-text text-lg italic mb-8 flex-grow" data-id="element-183">
                "{testimonial.quote}"
              </p>
              <div className="mt-auto pt-6 border-t border-gray-100" data-id="element-184">
                <p className="font-bold text-brand-navy" data-id="element-185">
                  {testimonial.author}
                </p>
                <p className="text-sm text-gray-600" data-id="element-186">
                  {testimonial.role} | {testimonial.location}
                </p>
              </div>
            </motion.div>)}
        </div>
      </div>
    </section>;
}